angular.module('dnecom')
    .controller('TransactionDetailsController', ["$scope", "$http", "notifications", "wizardModal", "$filter", function TransactionsDetailsController($scope, $http, notifications, wizardModal, $filter) {
        $scope.store = TemplateData.value('store');
        $scope.isPurelyServiceTransaction = TemplateData.value('isPurelyServiceTransaction');
        $scope.transaction = TemplateData.value('transaction');
        $scope.autoresponderHistory = TemplateData.value('autoresponderHistory');
        $scope.currencyCode = TemplateData.value('currencyCode');
        $scope.addedLists = [];
        $scope.removedLists = [];
        $scope.trackingProducts = [];
        $scope.transactionProductsDistincted = [];
        $scope.paymentMethod = $scope.transaction.payments[0] ? $scope.transaction.payments[0].paymentMethod :  null;

        $scope.getDistinctedProducts = function () {
            let distincted = [];
            for (let i = 0; i < $scope.transaction.products.length; i++) {
                let existing = distincted.find(function (item) {
                    return $scope.transaction.products[i].id == item.id
                        && $scope.transaction.products[i].variant == item.variant;
                })
                if (!existing && !$scope.transaction.products[i].isService) {
                    distincted.push($scope.transaction.products[i])
                }
            }

            return distincted;
        }

        $scope.isAutomaticRefundAvailable = function () {
            return !['pop','pod','paypal', 'payfast'].includes($scope.paymentMethod);
        }

        $scope.calculateAvailableForShippingSelect = function () {
            $scope.transactionProductsDistincted = $scope.getDistinctedProducts();
            $scope.trackingProducts.forEach(function (product) {
               $scope.transactionProductsDistincted = $scope.transactionProductsDistincted.filter(function (trProduct) {
                   return trProduct.id != product.id || trProduct.variant != product.variant;
               });
            });
            $scope.transaction.transactionShippings.forEach(function (shipping) {
                if (!shipping.isPartial) {
                    $scope.transactionProductsDistincted = [];
                } else {
                    shipping.items.forEach(function (item) {
                        $scope.transactionProductsDistincted = $scope.transactionProductsDistincted.filter(function (trProduct) {
                            return trProduct.id != item.id || trProduct.variant != item.variant;
                        });
                    });
                }
            });
        }

        $scope.calculateAvailableForShippingSelect();

        $scope.autoresponderHistory.forEach(function(item){
            if (item.action == 'added') {
                $scope.addedLists.push(item);
            } else if (item.action == 'removed') {
                $scope.removedLists.push(item);
            }
        });

        $scope.statusManager = (function () {
            var currentState = null;

            var availableStatuses = TemplateData.value('transactionStatuses');
            var allStatuses = TemplateData.value('allTransactionStatuses');

            var isStatusDefined = function (state) {
                return _.has(allStatuses, state);
            };

            return {
                setTo: function (state) {
                    if (!isStatusDefined(state)) {
                        throw 'State ' + state + ' is not a valid state';
                    }

                    currentState = state;
                    $scope.transaction.lastEmailDelivered = true;
                },

                isIn: function (state) {
                    var states = state;

                    if (!_.isArray(state)) {
                        states = [state]
                    }

                    var invalidStates = _.filter(states, function (state) {
                        return !isStatusDefined(state);
                    });

                    if (!_.isEmpty(invalidStates)) {
                        throw 'State ' + invalidStates.join(', ') + ' is not defined';
                    }

                    return _.some(states, function (state) {
                        return state === currentState;
                    });
                },

                getCurrent: function() {
                    return currentState;
                },

                getAll: function () {
                    return allStatuses;
                },
                getAllAvailableStatuses: function () {
                    return availableStatuses;
                },

                getNameByCode: function(state) {
                    var name = '';
                    if (typeof allStatuses[state] != "undefined") {
                        name = allStatuses[state];
                    }

                    return name;
                },

                refundAllowed: function () {
                    if (['new', 'processing', 'shipped', 'returned', 'done', 'ready_for_pickup'].indexOf(currentState) !== -1) {
                        return true;
                    }

                    return false;
                }
            }
        })();

        $scope.openAddressModal = function() {
            var addressModal = wizardModal.open({
                'templateUrl': 'addressModal.html',
                'size': 'md',
                'controller': function($scope, $uibModalInstance, transaction, isPurelyServiceTransaction) {
                    $scope.$uibModalInstance = $uibModalInstance;
                    $scope.transaction = transaction;
                    $scope.isPurelyServiceTransaction = isPurelyServiceTransaction;

                    var states = TemplateData.value('states');

                    $scope.states = [];

                    $scope.$watch('selected.country', function (newValue, oldValue) {
                        $scope.states = _.map(states[newValue.code], function (value, key) {
                            return { code: key, name: value };
                        });

                        $scope.transaction.shippingAddress.country = newValue.code;
                        $scope.transaction.shippingAddress.countryName = newValue.name;
                    });

                    $scope.$watch('selected.state', function (newValue, oldValue) {
                        $scope.transaction.shippingAddress.state = newValue.code;
                        $scope.transaction.shippingAddress.stateName = newValue.name;
                    });

                    $scope.countries = _.map(TemplateData.value('countries'), function (value, key) {
                        return { code: key, name: value };
                    });

                    $scope.selected = {
                        country: {
                            code: transaction.shippingAddress.country,
                            name: transaction.shippingAddress.countryName
                        },

                        state: {
                            code: transaction.shippingAddress.state,
                            name: transaction.shippingAddress.stateName
                        }
                    };


                    $scope.hasStates = function(countryCode) {
                        return states.hasOwnProperty(countryCode);
                    };
                },
                'resolve': {
                    'transaction': function() {
                        return angular.copy($scope.transaction);
                    },
                    'isPurelyServiceTransaction': function() {
                        return angular.copy($scope.isPurelyServiceTransaction);
                    }
                }
            });

            addressModal.result.then(function(transaction) {
                $scope.transaction = transaction;

                $scope.saveTransaction();
            });
        };

        $scope.openRefundInstructionsModal = function () {
            var refundInstructionsModal = wizardModal.open({
                'templateUrl': 'refundInstructionsModal.html',
                'size': 'md',
                'windowClass': 'modal-danger-light-header',
                'controller': function ($scope, $uibModalInstance, paymentMethod) {
                    $scope.paymentMethod = paymentMethod;
                    $scope.$uibModalInstance = $uibModalInstance;
                },
                'resolve': {
                    'paymentMethod': function() {
                        return $scope.paymentMethod;
                    }
                }
            });

            refundInstructionsModal.result.then(function (items) {
                $scope.openRefundModal();
            });
        };

        $scope.openRefundErrorModal = function (items) {
            var refundErrorModal = wizardModal.open({
                'templateUrl': 'refundErrorModal.html',
                'size': 'md',
                'windowClass': 'modal-danger-light-header',
                'controller': function ($scope, $uibModalInstance, items) {
                    $scope.$uibModalInstance = $uibModalInstance;
                    $scope.items = items;
                },
                'resolve': {
                    'items': function() {
                        return items;
                    }
                }
            });

            refundErrorModal.result.then(function (items) {
                $scope.processRefund(items, true);
            });
        };

        $scope.openRefundModal = function() {
            var refundModal = wizardModal.open({
                'templateUrl': 'refundModal.html',
                'size': 'lg',
                'windowClass': 'modal-danger-light-header modal-fit-main-content',
                'controller': function($scope, $uibModalInstance, filterFilter, currencyCode, transaction, isAutomaticRefundAvailable) {
                    $scope.$uibModalInstance = $uibModalInstance;
                    $scope.products = transaction.products.filter(function (product) {
                        return !product.isRefunded;
                    });
                    $scope.transaction = transaction;
                    $scope.isAutomaticRefundAvailable = isAutomaticRefundAvailable;
                    $scope.allSelected = false;
                    $scope.currencyCode = currencyCode;
                    $scope.selection = [];

                    $scope.selectedProducts = function() {
                        return filterFilter($scope.products, { selected: true });
                    };

                    $scope.getTotalQuantity = function() {
                        let quantity = 0;
                        $scope.products.forEach(function (product) {
                            quantity += product.quantity;
                        });
                        return quantity;
                    };

                    $scope.unselectAll = function () {
                        if (!$scope.allSelected) {
                            $scope.products.forEach(function (product) {
                                product.selected = false;
                            });
                        }
                    };

                    $scope.$watch('allSelected', function (nv) {
                        if (nv) {
                            $scope.products.forEach(function (product) {
                                product.selected = true;
                            });
                        }
                    }, true);



                    $scope.$watch('products|filter:{selected:true}', function (nv) {
                        $scope.selection = nv.map(function (product) {
                            return product;
                        });
                        if ($scope.allSelected && $scope.selection.length !== $scope.products.length) {
                            $scope.allSelected = false;
                        }
                    }, true);
                },
                'resolve': {
                    'transaction': function() {
                        return angular.copy($scope.transaction);
                    },
                    'currencyCode': function() {
                        return $scope.currencyCode;
                    },
                    'isAutomaticRefundAvailable': function() {
                        return $scope.isAutomaticRefundAvailable();
                    }
                }
            });

            refundModal.result.then(function(items) {
                $scope.openRefundConfirmModal(items);
            });
        };

        $scope.openRefundConfirmModal = function (products) {
            var refundConfirmModal = wizardModal.open({
                'templateUrl': 'refundConfirmModal.html',
                'size': 'md',
                'windowClass': 'modal-danger-light-header',
                'controller': function ($scope, $uibModalInstance, items) {
                    $scope.items = items;
                    $scope.$uibModalInstance = $uibModalInstance;
                },
                'resolve': {
                    'items': function() {
                        return products;
                    }
                }
            });

            refundConfirmModal.result.then(function (items) {
                $scope.processRefund(items, false);
            }, function () {
                $scope.openRefundModal();
            });
        };

        $scope.saveNote = function(noteText) {
            $scope.transaction.note = noteText;

            $scope.saveTransaction();
        };

        $scope.saveTracking = function() {
            if (
                ($scope.statusManager.getCurrent() == 'partially_shipped' && $scope.trackingProducts.length > 0)
                || $scope.statusManager.getCurrent() == 'shipped'
            ) {
                let data = [];
                if ($scope.statusManager.getCurrent() == 'partially_shipped') {
                    $scope.trackingProducts.forEach(item => {
                        data.push({id: item.id, variant: item.variant})
                    });
                }
                $http.post(Routing.generate('transaction_update_tracking', {
                    id: $scope.store.id,
                    transactionId: $scope.transaction.id
                }), {
                    trackingNumber: $scope.transaction.trackingNumber,
                    items: data,
                    transaction: $scope.transaction
                }).then(function (response) {
                        if (!response.data.success) {
                            notifications.danger(response.data.message);
                            return;
                        }

                        notifications.success(response.data.message);
                        if ($scope.statusManager.getCurrent() == 'shipped') {
                            $scope.transaction.trackingCourierName = response.data.item.trackingCourierName;
                            $scope.transaction.transactionShippings = [];
                        }
                        if ($scope.statusManager.getCurrent() == 'partially_shipped') {
                            $scope.transaction.trackingNumber = null;
                            $scope.transaction.trackingCourierName = null;
                            $scope.trackingProducts = [];
                            $scope.statusManager.setTo(response.data.transaction.status);
                            $scope.transaction.status = $scope.statusManager.getCurrent();
                            $scope.transaction.transactionShippings.push(response.data.item);
                        }
                        $scope.transaction.trackingNumber = null;
                        $scope.transaction.transactionShippings = response.data.transaction.transactionShippings;
                        $scope.calculateAvailableForShippingSelect();
                    }, function () {
                        notifications.danger('Request error.');
                    }).finally(function () {
                });
            }
        };

        $scope.deleteTrackingShipping = function(id) {
            $http.delete(Routing.generate('transaction_delete_tracking', {
                id: $scope.store.id,
                transactionShippingId: id
            }))
                .then(function (response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    notifications.success(response.data.message);
                    $scope.transaction.transactionShippings = $scope.transaction.transactionShippings.filter(function (shipping) {
                        return shipping.id != id;
                    });
                    $scope.calculateAvailableForShippingSelect();
                }, function () {
                    notifications.danger('Request error.');
                }).finally(function () {
            });
        }

        $scope.deleteProductFromTrackingSearh = function (id) {
            $scope.trackingProducts = $scope.trackingProducts.filter(function (product) {
                return product.id != id;
            });
            $scope.calculateAvailableForShippingSelect();
        }

        $scope.getTrackingProductRow = function (tracking) {
            let row = [];
            if (tracking.items && tracking.items.length) {
                tracking.items.forEach(function (item) {
                    let product = $scope.transaction.products.find(function (product) {
                        return product.id == item.id && product.variant == item.variant;
                    });
                    row.push($scope.getNameWithVariant(product));
                });
            } else {
                $scope.getDistinctedProducts().forEach(function (product) {
                    row.push($scope.getNameWithVariant(product));
                })
            }

            return row.join(', ');
        }

        $scope.getNameWithVariant = function (product) {
            if (!product) {
                return null;
            }
            let row = [];
            product.attributes.forEach(function (attribute) {
                row.push(attribute.name +  ' - ' + attribute.label)
            });
            let result = product.name;
            if (row.length) {
                result = result + '(' + row.join(',') + ')';
            }
            return result;
        }

        $scope.trackingProductAdd = function(item, model) {
            var existing = $scope.trackingProducts.find(function (product){
                return product.id == item.id && product.variant == item.variant;
            });
            if (!existing) {
                if (item.quantity > 0) {
                    $scope.trackingProducts.push(item);
                }
            }
            $scope.calculateAvailableForShippingSelect();
        };

        $scope.getPrimaryImageUrl = function (product) {
            return $filter('mediaSrc')(product);
        };

        $scope.saveStatus = function(status) {
            if (!_.isUndefined(status)) {
                $scope.statusManager.setTo(status);
            }

            $scope.transaction.status = $scope.statusManager.getCurrent();
            $scope.saveTransaction();
        };

        $scope.saveTransaction = function() {
            $http.put(Routing.generate('transaction_update', {
                    id: $scope.store.id,
                    transactionId: $scope.transaction.id
                }), $scope.transaction)
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    notifications.success(response.data.message);
                }, function() {
                    notifications.danger('Request error.');
                }).finally(function() {
                    $scope.transaction.sendStatusChangeMessage = false;
                });
        };

        $scope.processRefund = function(items, markOnly) {
            $http.put(Routing.generate('transaction_refund', {
                id: $scope.store.id,
                transactionId: $scope.transaction.id
            }), {items: items, markOnly: markOnly})
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    $scope.transaction = response.data.transaction;
                    $scope.statusManager.setTo(response.data.transaction.status)
                }, function() {
                    $scope.openRefundErrorModal();
                }).finally(function() {
            });
        };

        $scope.statusManager.setTo($scope.transaction.status);

        $scope.isProductRefunded = function (id, tag) {
            var refunded = false
            $scope.transaction.products.forEach(function (product) {
                if (product.id == id && product.tag == tag && product.isRefunded) {
                    refunded = true;
                };
            });

            return refunded;
        }

        $scope.$on('transaction.payment.status.changed', function () {
            var statuses = [];
            $scope.transaction.payments.forEach(function(payment) {
                if (statuses.indexOf(payment.status) == -1) {
                    statuses.push(payment.status);
                }
            });

            // ir there is at least 1 done payment, transaction could not be 'returned'
            if (statuses.indexOf('done') != -1 && $scope.transaction.status == 'returned') {
                $scope.saveStatus('new');
            }

            // no done payments, all returned => transaction also must me returned
            if (statuses.indexOf('returned') != -1 && statuses.indexOf('done') == -1 && $scope.transaction.status != 'returned') {
                $scope.saveStatus('returned');
            }
        });

        $scope.setPaymentStatus = function (payment, status) {
            $http.get(Routing.generate('transaction_payment_set_status', {
                    id: $scope.store.id,
                    paymentId: payment.id,
                    status: status
                }))
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }
                    payment.status = status;
                    notifications.success(response.data.message);
                    $scope.$emit('transaction.payment.status.changed');
                }, function() {
                    notifications.danger('Request error.');
                });
        };
    }]);

angular.module('dnecom')
    .directive('noteWidget', function () {
        return {
            templateUrl: 'note-widget.html',
            restrict: 'A',
            scope: {
                submit: '&',
                initialValue: '='
            },
            link: function (scope) {
                scope.$watch('initialValue', function(newInitialValue) {
                    scope.edited = false;
                    scope.noteText = scope.originalNoteText = (newInitialValue || '');
                });

                scope.onNoteChange = function(newNoteText) {
                    scope.edited = newNoteText !== scope.originalNoteText;
                };
            }
        }
    });

angular.module('dnecom')
    .directive('statusWidget', function () {
        return {
            templateUrl: 'status-widget.html',
            restrict: 'A',
            link: function (scope) {
                var defaultOrder = [
                    'new',
                    'processing',
                    'partially_shipped',
                    'shipped',
                    'out_for_delivery',
                    'delivered',
                    'ready_for_pickup',
                    'done',
                    'returned',
                    'incomplete',
                    'abandoned'
                ];

                scope.switched = false;

                scope.statuses = _.toPairs(scope.statusManager.getAllAvailableStatuses()).sort(function (leftState, rightState) {
                    return defaultOrder.indexOf(leftState[0]) - defaultOrder.indexOf(rightState[0]);
                });

                scope.changeStatus = function(status) {
                    scope.statusManager.setTo(status);
                    scope.switched = true;
                };

                scope.persist = function() {
                    scope.saveStatus();
                    scope.switched = false;
                }
            }
        }
    });
